import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ScullyRoute, ScullyRoutesService } from '@scullyio/ng-lib';

@Component({
  selector: 'recent-blogs',
  templateUrl: './recent-blogs.component.html',
  styleUrls: ['./recent-blogs.component.css']
})
export class RecentBlogsComponent implements OnInit {

  //declare variables
  posts: ScullyRoute[];
  showPosts: ScullyRoute[];

  //inject services
  constructor(private scully: ScullyRoutesService, private router: Router) { }

  //initialize the component
  ngOnInit(): void {
    //get the available routes
    this.scully.available$.subscribe(data => {
      //get only blog posts
      this.posts = data.filter(x => x.route.startsWith('/blog/') == true);
      //sort by date published descending
      this.sort(this.posts);
      //take most recent three
      this.showPosts = this.posts.slice(0, 3);
    });
  }

  //sort the array
  sort(array: any[]) {
    this.showPosts = array.sort(function (a, b) {
      var firstValue = a.datePublished;
      var secondValue = b.datePublished;
      if (firstValue > secondValue) {
        return -1;
      } else {
        return 1;
      }
    });
  }

  //navigate to the provided URL
  navigate(strUrl) {
    this.router.navigate([strUrl]);
  }

}
